import React from 'react';
import AllBooks from '../components/AllBooks';

const BooksPage = () => (
  <div>
    <AllBooks />
  </div>
);

export default BooksPage;
